import React from 'react'
import styled from 'styled-components'
import LocationContainer from '../LocationContainer'
import { TextContainerStyles } from '../../../styles/inner-sidebar-single'

class ItemBody extends React.Component {
    render() {
        const { post } = this.props
        const { phone, url, image, name, city, subway } = post
        const { address } = post.location
  
        return(
          <Main>
              <LocationContainer data={{address, phone, url, subway}}/>
              <TextContainerStyles>
                <img src={image} alt={`${name} in ${city}`} />
                <TextContainer dangerouslySetInnerHTML={{ __html: post.description }} />
              </TextContainerStyles>
              </Main>
        )
    }

}


const Main = styled.div`
  border-bottom: 20px solid #f5f5f5;
`;

const TextContainer = styled.div`
`;


export default ItemBody;